<template>
  <div class="promocode-item" :class="{'is-favorite': isFavorite}" @click="openStore">
    <button class="promocode-favorite" @click.stop="toggleSaved"></button>
    <div class="promocode-image">
      <div class="image-placeholder" v-lazy-container="{ selector: 'img'}">
        <img :class="{'placeholder-image': logoIsError}" :data-src="logoIsError ? imgPlaceholder() : computed_logo" alt="logo"
             :data-error="imgPlaceholder()">
      </div>
    </div>
    <div class="promocode-content">
      <h4 class="promocode-title">{{ name }}</h4>
      <div class="promocode-text" v-if="description">{{ description }}</div>
      <div class="promocode-footer" v-if="providers">
        <div class="promocode-cashback" v-if="cashback_max_description" :title="cashback_max_description"><span v-if="cashback_max">Cashback</span> {{ cashback_max || cashback_max_description }}{{cashback_max_currency}}</div>
        <div class="promocode-coupon" v-if="offers_count === 0">No deals available</div>
        <div class="promocode-coupon" v-else>{{ offers_count }} deal <span v-if="offers_count > 1">s</span>  </div>
      </div>
    </div>
  </div>
</template>

<script>
import {reportEvent} from "@/utils";

export default {
  props: ['id', 'name', 'cashback_max_currency', 'cashback_max_description', 'offers_count', 'cashback_max', 'description', 'icon', 'host', 'image', 'link', 'providers', 'saved', 'computed_logo', 'website'],
  name: 'StoreItem',
  data: function (){
    return {
      loading: true,
      swapped: false,
      logoIsError: false
    }
  },
  computed: {
    isFavorite() {
      return this.saved && this.saved.some(item => item.name === this.name)
    }
  },
  mounted () {
    const img = new Image();
    img.src = this.computed_logo;
    const $this = this
    img.onload = function() {
      if (this.width < 10){
        $this.logoIsError = true
        $this.swapped = true
      }
    }
  },
  methods: {
    toggleSaved (){
      let savedItems = JSON.parse(localStorage.getItem('saved'));
      savedItems = savedItems ? savedItems : []
      const index = savedItems ? savedItems.findIndex(item => item.name === this.name) : null
      if (index !== -1) {
        savedItems.splice(index, 1)
        reportEvent('favorite', {
          action: 'remove',
          key: this.host
        })
      } else {
        const savedStore = {
          id: this.id,
          name: this.name,
          description: this.description,
          offers_count: this.offers_count,
          computed_logo: this.computed_logo,
          host: this.host,
          link: this.link,
          providers: this.providers,
          cashback_max: this.cashback_max,
          cashback_max_currency: this.cashback_max_currency,
          cashback_max_description: this.cashback_max_description,
          website: this.website,
        }
        savedItems.push(savedStore)
        reportEvent('favorite', {
          action: 'add',
          key: this.host
        })
      }
      this.$emit('changesaved', savedItems)
    },
    openStore () {
      const storeData = {
        id: this.id,
        name: this.name,
        description: this.description,
        computed_logo: this.computed_logo,
        link: this.link,
        host: this.host,
        providers: this.providers,
        offers_count: this.offers_count,
        cashback_max_description: this.cashback_max_description,
        cashback_max: this.cashback_max,
        cashback_max_currency: this.cashback_max_currency,
        website: this.website,
      }

      this.$emit('openstore', storeData)
      reportEvent('store', {
        action: 'view',
        key: this.host,
        ref: 'home'
      })
    },
    imgPlaceholder() {
      return require('../assets/img/cashback-icon.svg');
    }
  }
}
</script>
